import ActionConstants from '../constants/ActionConstants';
import { sendChatbotMessage } from '../../api/chatbot';

export const toggleChatbotVisibility = () => ({
  type: ActionConstants.CHATBOT_TOGGLE_VISIBILITY,
});

export const addMessage = (message) => ({
  type: ActionConstants.CHATBOT_ADD_MESSAGE,
  payload: message,
});

export const clearMessages = () => ({
  type: ActionConstants.CHATBOT_CLEAR_MESSAGES,
});

export const setLoading = (loading) => ({
  type: ActionConstants.CHATBOT_SET_LOADING,
  payload: loading,
});

export const sendMessage = (message) => async (dispatch, getState) => {
  const { chatbot } = getState();

  dispatch({
    type: ActionConstants.CHATBOT_SEND_MESSAGE_REQUEST,
  });

  // Add user message immediately
  dispatch(
    addMessage({
      id: Date.now(),
      text: message,
      sender: 'user',
      timestamp: new Date().toISOString(),
    })
  );

  try {
    const response = await sendChatbotMessage(message, chatbot.sessionId);
    dispatch(
      addMessage({
        id: Date.now() + 1,
        text:
          response.body.data.response ||
          'Sorry, something went wrong. Please try again.',
        sender: 'bot',
        timestamp: new Date().toISOString(),
      })
    );

    dispatch({
      type: ActionConstants.CHATBOT_SEND_MESSAGE_SUCCESS,
    });
  } catch (error) {
    dispatch(
      addMessage({
        id: Date.now() + 1,
        text: 'Sorry, something went wrong. Please try again.',
        sender: 'bot',
        timestamp: new Date().toISOString(),
      })
    );

    dispatch({
      type: ActionConstants.CHATBOT_SEND_MESSAGE_FAILURE,
      payload: error.message,
    });
  }
};
